import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Basket } from '../types/basket.type';
import { ADMIN_BASKETS_API_PATHS } from '../constants/baskets-api-paths.constants';

type UseRestoreBasketResult = {
  restoreBasket: (basketId: string) => Promise<Basket | null>;
  isSubmitting: boolean;
};

export function useRestoreBasket(): UseRestoreBasketResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const restoreBasket = async (basketId: string): Promise<Basket | null> => {
    setIsSubmitting(true);

    try {
      const restoredBasket = await HttpClient.post<Basket>(ADMIN_BASKETS_API_PATHS.RESTORE_BASKET(basketId));

      enqueueSnackbar('Panier restauré', { variant: 'success' });
      return restoredBasket;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la restauration du panier'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { restoreBasket, isSubmitting };
}
